/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const deviceRowSchema = z.object({
  id: z.string(),
  userId: z.string(),
  platform: z.string(),
  deviceModel: z.string(),
  osName: z.string().nullable(),
  osVersion: z.string().nullable(),
  browserName: z.string().nullable(),
  browserVersion: z.string().nullable(),
  userAgent: z.string().nullable(),
  lastSeenAt: z.number(),
  createdAt: z.number(),
});

export const userDevicesNotificationsV1DataSchema = z.object({
  userId: z.string(),
  devices: z.array(deviceRowSchema),
});

export type IUserDevicesNotificationsV1Data = z.infer<typeof userDevicesNotificationsV1DataSchema>;
export type IUserDeviceRow = z.infer<typeof deviceRowSchema>;

export const getUserDevicesNotificationsV1ResponseSchema = createApiResponseSchema(
  userDevicesNotificationsV1DataSchema,
) as z.ZodSchema<IAPI<IUserDevicesNotificationsV1Data>>;

export type IGetUserDevicesNotificationsV1Response = IAPI<IUserDevicesNotificationsV1Data>;
